import { ValidationResult } from '../../../../../../../../../ui/gzForm/formField/types/form-validator';
import { ContentControlDataProtectionRule } from '@nirvana/shared/dtos/types/policies/common';
import { translateFn } from '../../../../../../../../../utils/translator.helper';

// validate duplicates
export function validateNameDuplicates(
  exclusionItem: ContentControlDataProtectionRule,
  exclusionsInGrid: ContentControlDataProtectionRule[]
): ValidationResult {
  const hasDuplicates = exclusionsInGrid.some(
    (exclusionInGrid: ContentControlDataProtectionRule) => exclusionInGrid.name === exclusionItem.name
  );

  if (hasDuplicates) {
    return {
      valid: false,
      error: translateFn('The entry already exists.'),
    };
  }

  return {
    valid: true,
  };
}

export function validateStringDuplicates(
  exclusionItem: ContentControlDataProtectionRule,
  exclusionsInGrid: ContentControlDataProtectionRule[]
): ValidationResult {
  const firstMatch = exclusionsInGrid.find(
    (exclusionInGrid: ContentControlDataProtectionRule) =>
      exclusionInGrid.type === exclusionItem.type && exclusionInGrid.string === exclusionItem.string
  );

  if (firstMatch) {
    return {
      valid: false,
      error: translateFn('The entry {string} of the same type already exists in the rule named {name}.', {
        string: exclusionItem.string,
        name: firstMatch.name,
      }),
    };
  }

  return {
    valid: true,
  };
}
